import { render, staticRenderFns } from "./EditDocumentModal.vue?vue&type=template&id=76cf3166&scoped=true"
import script from "./EditDocumentModal.vue?vue&type=script&lang=js"
export * from "./EditDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./EditDocumentModal.vue?vue&type=style&index=0&id=76cf3166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf3166",
  null
  
)

export default component.exports